<template>
  <div class="step step-one">
    <h2 class="step__title">Tell us more</h2>
    <p class="step__description">Please fill in the required data.</p>
    <UIInputText name="social_network" label="Link to your social media (optional)" placeholder="Type your answer" />
    <UIInputText name="preferred_messenger" label="Your Telegram/WhatsApp/Skype?" placeholder="Type your answer" />
    <UIInputText name="messenger_username" label="Your username or tag in messenger?" placeholder="Username" />
    <UIInputText name="other_details" label="Additional information (optional)" placeholder="Type your answer" />
    <UIButton id="step-three-next" :loading="loading" @click="emit('register')">Register</UIButton>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'register'): void
}>()
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';

@include questionnaireStep();
</style>
